import { render, staticRenderFns } from "./AbaDeServicosDoIrmao.vue?vue&type=template&id=516828b6"
import script from "./AbaDeServicosDoIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbaDeServicosDoIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports